var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "#AEB6CE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19621 11.3038C0.805689 10.9133 0.805689 10.2801 1.19621 9.88958L10.3886 0.69719C10.7791 0.306666 11.4123 0.306666 11.8028 0.69719C12.1933 1.08771 12.1933 1.72088 11.8028 2.1114L2.61043 11.3038C2.2199 11.6943 1.58674 11.6943 1.19621 11.3038Z",
    fill: "#AEB6CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19621 0.69719C1.58674 0.306666 2.2199 0.306666 2.61043 0.69719L11.8028 9.88958C12.1933 10.2801 12.1933 10.9133 11.8028 11.3038C11.4123 11.6943 10.7791 11.6943 10.3886 11.3038L1.19621 2.1114C0.805689 1.72088 0.805689 1.08771 1.19621 0.69719Z",
    fill: "#AEB6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.aadd0b480ecc872e56a4916125f29d3a.svg";
export { ForwardRef as ReactComponent };